import { Link } from 'react-router-dom';
import { NexusMark } from '@/components/NexusMark';
import { features } from '@/content/features';

const columns = [
  {
    title: 'Platform',
    links: [
      ...features.slice(0, 4).map((f) => ({ label: f.title, to: `/platform/${f.slug}` })),
      { label: 'All modules', to: '/platform' },
      { label: 'Integrations', to: '/integrations' },
    ],
  },
  {
    title: 'Solutions',
    links: [
      { label: 'For small MSPs', to: '/for-small-msps' },
      { label: 'For growing MSPs', to: '/solutions/growing-msps' },
      { label: 'For MSP owners', to: '/solutions/msp-owners' },
      { label: 'For technicians', to: '/solutions/technicians' },
      { label: 'For vCIOs', to: '/solutions/vcio' },
      { label: 'For security-first MSPs', to: '/solutions/security-first-msps' },
      { label: 'IT consolidation', to: '/solutions/it-consolidation' },
      { label: 'For MSPs serving schools', to: '/solutions/education' },
      { label: 'For MSPs serving healthcare', to: '/solutions/healthcare' },
      { label: 'For MSPs serving financial services', to: '/solutions/financial-services' },
      { label: 'For MSPs serving nonprofits', to: '/solutions/nonprofits' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'All resources', to: '/resources' },
      { label: "What's new", to: '/whats-new' },
      { label: "Buyer's guide", to: '/buyers-guide' },
      { label: 'Compare Nexus', to: '/compare' },
      { label: 'Glossary', to: '/glossary' },
      { label: 'Roadmap', to: '/roadmap' },
      { label: 'Blog', to: '/blog' },
    ],
  },
  {
    title: 'Company & trust',
    links: [
      { label: 'About', to: '/about' },
      { label: 'Press & brand', to: '/press' },
      { label: 'Contact', to: '/contact' },
      { label: 'Security', to: '/security' },
      { label: 'Compliance', to: '/compliance' },
      { label: 'Privacy policy', to: '/privacy' },
      { label: 'Terms of use', to: '/terms' },
    ],
  },
];

export function Footer(): JSX.Element {
  return (
    <footer className="border-t border-white/10 py-14">
      <div className="container-content">
        <div className="grid grid-cols-2 gap-10 pb-10 sm:grid-cols-3 lg:grid-cols-5">
          <div className="col-span-2 sm:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 no-underline">
              <NexusMark size={22} />
              <span className="font-display text-base font-semibold text-nexus-ink">Nexus</span>
            </Link>
            <p className="mt-3 max-w-[200px] text-sm text-white/50">Monitor. Manage. Maximize.</p>
          </div>
          {columns.map((col) => (
            <div key={col.title}>
              <p className="text-xs font-bold uppercase tracking-[0.1em] text-white/40">{col.title}</p>
              <ul className="mt-3 flex flex-col gap-2.5">
                {col.links.map((l) => (
                  <li key={l.to}>
                    {l.to.startsWith('mailto:') ? (
                      <a href={l.to} className="text-sm text-white/65 no-underline hover:text-white">
                        {l.label}
                      </a>
                    ) : (
                      <Link to={l.to} className="text-sm text-white/65 no-underline hover:text-white">
                        {l.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-6 sm:flex-row sm:items-center">
          <span className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} Elemental TS &middot; nexusrmm.ai
          </span>
          <span className="text-xs text-white/40">
            Building in the open —{' '}
            <Link to="/roadmap" className="text-white/50 underline hover:text-white/70">
              see the roadmap
            </Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
